// extracted by mini-css-extract-plugin
export default {"tetherUsdtIcon":"TetherUSDTIcon_tetherUsdtIcon__Mk4Rf"};